(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rt-b2b-native"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rt-b2b-status')) {
    customElements.define('rt-b2b-status', class extends HTMLElement {
      connectedCallback() {
        this.refresh = () => {
          const hide = (node, hidden) => { if (node && node.hidden !== hidden) node.hidden = hidden; };
          const fresh = this.dataset.verified === 'true' && Number(this.dataset.expires) > Date.now();
          const current = this.querySelector('[data-current]');
          hide(current, !fresh);
          hide(this.querySelector('[data-confirm]'), fresh);
          const count = Number(this.closest('product-info')?.querySelector('[name="quantity"]')?.value || 1);
          this.querySelectorAll('[data-stock-line]').forEach(line => {
            const currentStock = line.dataset.verified === 'true' && Number(line.dataset.expires) > Date.now();
            const value = line.querySelector('[data-stock-current]');
            hide(value, !currentStock);
            hide(line.querySelector('[data-stock-confirm]'), currentStock);
            const priceNote = line.querySelector('[data-supplier-price-confirm]');
            hide(priceNote, fresh && line.dataset.priceMatches === 'true');
            const withinStock = count <= Number(line.dataset.quantity);
            hide(line.querySelector('[data-stock-eta]'), !withinStock);
            hide(line.querySelector('[data-stock-eta-confirm]'), withinStock);
          });
          const warning = this.querySelector('[data-over-quantity]');
          hide(warning, count <= Number(this.dataset.quantity));
        };
        this.form = this.closest('product-info');
        this.form?.addEventListener('change', this.refresh);
        this.timer = setInterval(this.refresh, 1000);
        this.refresh();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.form?.removeEventListener('change', this.refresh);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rt-b2b-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rt-b2b-order')) {
    customElements.define('rt-b2b-order', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-intent]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const add = btn.hasAttribute('data-add');
            if (btn.dataset.intent === 'check') this.openCheck(add);
            else this.send({ intent: 'order', add });
          });
        });
        this.querySelector('[data-send-check]').addEventListener('click', () => {
          this.send({ intent: 'check', add: this.checkAdds, note: this.querySelector('textarea').value.trim() });
        });
        this.querySelector('[data-cancel]').addEventListener('click', () => (this.querySelector('[data-check]').hidden = true));
        this.querySelector('[data-stay]').addEventListener('click', () => this.send({ add: true, stay: true }));
      }
      openCheck(add) {
        this.checkAdds = add;
        this.querySelector('[data-check]').hidden = false;
        this.querySelector('textarea').focus();
      }
      say(text, error) {
        const status = this.querySelector('[data-status]');
        status.textContent = text;
        status.classList.toggle('is-error', !!error);
        status.hidden = !text;
      }
      lock(on) {
        this.busy = on;
        this.querySelectorAll('button').forEach((b) => (b.disabled = on));
      }
      async send({ intent, add, note, stay }) {
        if (this.busy) return;
        const input = this.querySelector('input[name="quantity"]');
        const qty = Math.floor(Number(input.value));
        if (add && !(qty >= 1 && qty <= 99)) {
          this.say(window.rtB2bOrderText.badQty, true);
          input.focus();
          return;
        }
        this.lock(true);
        this.say('');
        const label = intent === 'check' ? 'Check it' : 'Place order';
        try {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const post = async (path, body) => {
            const res = await fetch(root + path, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            });
            if (!res.ok) throw new Error(path + ' ' + res.status);
            return res;
          };
          if (add) {
            const item = { id: Number(this.dataset.variantId), quantity: qty };
            if (intent) {
              item.properties = { '_Dealer request': label };
              if (note) item.properties['Dealer note'] = note;
            }
            await post('cart/add.js', { items: [item] });
          }
          if (stay) {
            const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
            this.querySelector('[data-count]').textContent = cart.item_count;
            this.querySelector('[data-review]').hidden = !(cart.item_count > 0);
            this.say(window.rtB2bOrderText.added.replace('__QTY__', qty));
            return;
          }
          await post('cart/update.js', {
            attributes: { 'Dealer request': label, 'Dealer note': intent === 'check' ? note || '' : '' },
            note: intent === 'check' ? note || '' : '',
          });
          this.leaving = true;
          window.location.href = root + 'checkout';
          return;
        } catch (err) {
          this.say(window.rtB2bOrderText.failed, true);
        } finally {
          if (!this.leaving) this.lock(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rt-variant-fitment-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rt-variant-part-numbers')) {
    customElements.define(
      'rt-variant-part-numbers',
      class extends HTMLElement {
        connectedCallback() {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const productInfo = this.closest('product-info');
            if (!productInfo || event.data.sectionId !== productInfo.dataset.section) return;

            const source = event.data.html.querySelector(
              `rt-variant-part-numbers[data-product-id="${this.dataset.productId}"]`
            );
            if (!source) return;

            const update = () => {
              this.innerHTML = source.innerHTML;
            };

            if (document.startViewTransition) {
              document.startViewTransition(update);
            } else {
              update();
            }
          });
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
